// LEASE_OPTIONAL_MONTH_V1
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import API from '../utils/api';
import FaceCamera from '../components/FaceCamera';

// V2.9 ACCOUNT REGISTRATION REVIEW
// V2.9.1 APPROVE AUTO FACE SYNC
const natural=(a,b)=>String(a).localeCompare(String(b),'zh-CN',{numeric:true});
const parseProperty=property=>{const text=String(property.room_no||'');const match=text.match(/^(\d+幢)(\d+单元)(\d+)室$/);if(!match)return {...property,_building:'其他',_unit:'未分单元',_floor:'',_room:text};const digits=match[3];return {...property,_building:match[1],_unit:match[2],_floor:digits.slice(0,-2),_room:digits.slice(-2)};};

export default function Register(){
  const navigate=useNavigate();
  const [properties,setProperties]=useState([]),[building,setBuilding]=useState(''),[unit,setUnit]=useState(''),[floor,setFloor]=useState(''),[propertyId,setPropertyId]=useState('');
  const [residentType,setResidentType]=useState('业主'),[parking1,setParking1]=useState(''),[parking2,setParking2]=useState(''),[plate1,setPlate1]=useState(''),[plate2,setPlate2]=useState(''),[plate3,setPlate3]=useState(''),[plate4,setPlate4]=useState(''),[showParking2,setShowParking2]=useState(false);
  const [idCardPreview,setIdCardPreview]=useState(null),[facePreview,setFacePreview]=useState(null),[idCardFile,setIdCardFile]=useState(null),[faceFile,setFaceFile]=useState(null);
  const [leaseContractFile,setLeaseContractFile]=useState(null);
  const [leaseContractName,setLeaseContractName]=useState('');
  // LEASE_CAPTURE_FIX_V1
  const [leaseContractPreview,setLeaseContractPreview]=useState('');

  const [leaseStartDate,setLeaseStartDate]=useState('');
  const [leaseEndDate,setLeaseEndDate]=useState('');
  const [loading,setLoading]=useState(false),[error,setError]=useState(''),[success,setSuccess]=useState(false);
  const [cameraOpen,setCameraOpen]=useState(false);
  const [smsCode,setSmsCode]=useState('');
  const [smsVerified,setSmsVerified]=useState(false);
  const [verifiedPhone,setVerifiedPhone]=useState('');
  const [smsBusy,setSmsBusy]=useState(false);
  const [smsInfo,setSmsInfo]=useState('');
  const [smsCooldown,setSmsCooldown]=useState(0);
  const passwordRef=useRef(null),password2Ref=useRef(null),nameRef=useRef(null),phoneRef=useRef(null),idCardNoRef=useRef(null),workplaceRef=useRef(null);

  useEffect(()=>{API.get('/users/register/properties').then(r=>setProperties((r.data||[]).map(parseProperty))).catch(e=>setError(e.response?.data?.message||'房屋资料加载失败'));},[]);

  useEffect(()=>{
    if(smsCooldown<=0)return;
    const timer=setTimeout(()=>setSmsCooldown(v=>Math.max(0,v-1)),1000);
    return ()=>clearTimeout(timer);
  },[smsCooldown]);
  const buildings=useMemo(()=>[...new Set(properties.map(p=>p._building))].sort(natural),[properties]);
  const units=useMemo(()=>[...new Set(properties.filter(p=>p._building===building).map(p=>p._unit))].sort(natural),[properties,building]);
  const floors=useMemo(()=>[...new Set(properties.filter(p=>p._building===building&&p._unit===unit).map(p=>p._floor))].filter(Boolean).sort((a,b)=>Number(a)-Number(b)),[properties,building,unit]);
  const rooms=useMemo(()=>properties.filter(p=>p._building===building&&p._unit===unit&&p._floor===floor).sort((a,b)=>natural(a._room,b._room)),[properties,building,unit,floor]);
  const selected=properties.find(p=>String(p.id)===String(propertyId));
  const slotCount=residentType==='业主'?Number(selected?.owner_accounts||0):Number(selected?.tenant_accounts||0);
  const chooseFile=(event,setFile,setPreview)=>{const file=event.target.files?.[0];if(!file)return;setFile(file);setPreview(URL.createObjectURL(file));};
  const resetParking=()=>{setParking1('');setParking2('');setPlate1('');setPlate2('');setPlate3('');setPlate4('');setShowParking2(false);};
  const resetBelow=level=>{if(level==='building'){setUnit('');setFloor('');}if(level==='unit')setFloor('');setPropertyId('');resetParking();};

  const resetSmsVerification=()=>{
    setSmsCode('');
    setSmsVerified(false);
    setVerifiedPhone('');
    setSmsInfo('');
  };

  const sendSms=async()=>{
    setError('');
    setSmsInfo('');

    const phone=String(phoneRef.current?.value||'').replace(/\D/g,'');

    if(!/^1\d{10}$/.test(phone))
      return setError('请输入正确的11位手机号码');

    setSmsBusy(true);

    try{
      const r=await API.post('/users/register/sms/send',{phone});
      setSmsCooldown(Number(r.data?.resend_after||60));
      setSmsInfo(r.data?.message||'验证码已发送，请查收短信');
    }catch(e){
      setError(e.response?.data?.message||'验证码发送失败');
    }finally{
      setSmsBusy(false);
    }
  };

  const verifySms=async()=>{
    setError('');
    setSmsInfo('');

    const phone=String(phoneRef.current?.value||'').replace(/\D/g,'');
    const code=String(smsCode||'').replace(/\D/g,'');

    if(!/^1\d{10}$/.test(phone))
      return setError('请输入正确的11位手机号码');

    if(!/^\d{6}$/.test(code))
      return setError('请输入6位短信验证码');

    setSmsBusy(true);

    try{
      const r=await API.post('/users/register/sms/verify',{phone,code});
      setSmsVerified(true);
      setVerifiedPhone(phone);
      setSmsInfo(r.data?.message||'手机号码验证成功');
    }catch(e){
      setSmsVerified(false);
      setVerifiedPhone('');
      setError(e.response?.data?.message||'验证码验证失败');
    }finally{
      setSmsBusy(false);
    }
  };


  useEffect(()=>{
    if(!leaseContractFile){
      setLeaseContractPreview('');
      return;
    }
    const url=URL.createObjectURL(leaseContractFile);
    setLeaseContractPreview(url);
    return ()=>URL.revokeObjectURL(url);
  },[leaseContractFile]);

  const handleSubmit=async()=>{
    const password=passwordRef.current?.value||'',password2=password2Ref.current?.value||'',real_name=nameRef.current?.value.trim()||'',phone=String(phoneRef.current?.value||'').replace(/\D/g,''),id_card_no=(idCardNoRef.current?.value.trim()||'').toUpperCase(),workplace=workplaceRef.current?.value.trim()||'',parking_space_no=parking1,parking_space_no_2=showParking2?parking2:'',plate_no=plate1.trim().toUpperCase(),plate_no_2=plate2.trim().toUpperCase(),plate_no_3=showParking2?plate3.trim().toUpperCase():'',plate_no_4=showParking2?plate4.trim().toUpperCase():'';
    if(!password||!real_name||!phone)return setError('请填写姓名、手机号码和密码');
    if(!/^1\d{10}$/.test(phone))return setError('请输入正确的11位手机号码');
    if(!smsVerified||verifiedPhone!==phone)return setError('请先完成手机短信验证');
    if(!id_card_no)return setError('请录入身份证号码以便物业核验');
    if(!/^\d{17}[\dX]$/.test(id_card_no))return setError('请填写正确的18位身份证号码');
    if(password.length<6)return setError('密码至少6位');
    if(password!==password2)return setError('两次密码不一致');
    if(!selected)return setError('请按幢、单元、楼层选择房号');
    if(slotCount>=2)return setError(`该房屋已经注册2个${residentType}账号`);
    if(!faceFile)return setError('请拍摄本人正脸照，物业审核通过后将自动同步门禁');
    if(residentType==='租户'&&!workplace)return setError('租户必须填写工作单位/工作地点');
    if(residentType==='租户'&&!idCardFile)return setError('请上传本人身份证照片');
  
  if(residentType==='租户'&&leaseContractFile&&leaseStartDate&&leaseEndDate&&leaseEndDate<leaseStartDate)
    return setError('租赁到期日期不能早于租赁开始日期');
    if(residentType==='业主'&&!parking_space_no)return setError('请选择第一个车位，无车位请选择“无”');
    const validParking=no=>/^\d{3}$/.test(no)&&Number(no)>=1&&Number(no)<=660;
    if(residentType==='业主'&&parking_space_no!=='无'&&!validParking(parking_space_no))return setError('车位号只能选择001-660，或选择“无”');
    if(residentType==='业主'&&parking_space_no==='无'&&(plate_no||plate_no_2||showParking2))return setError('选择“无车位”时不能登记车牌或第二个车位');
    if(residentType==='业主'&&showParking2&&!parking_space_no_2)return setError('请选择第二个车位，或点击“移除车位2”');
    if(residentType==='业主'&&parking_space_no_2&&!validParking(parking_space_no_2))return setError('第二个车位号只能选择001-660');
    if(residentType==='业主'&&parking_space_no_2&&parking_space_no_2===parking_space_no)return setError('两个车位号不能相同');
    const plateKey=value=>String(value||'').replace(/[·\s-]/g,'').toUpperCase();
    const plateValues=[plate_no,plate_no_2,plate_no_3,plate_no_4].filter(Boolean);
    if(residentType==='业主'&&new Set(plateValues.map(plateKey)).size!==plateValues.length)return setError('车牌号不能重复');
    setLoading(true);setError('');
    try{const data=new FormData();data.append('password',password);data.append('real_name',real_name);data.append('phone',phone);data.append('id_card_no',id_card_no);data.append('property_id',selected.id);data.append('resident_type',residentType);
      if(idCardFile)data.append('id_card_photo',idCardFile);
      data.append('face_photo',faceFile);
      if(residentType==='业主'){data.append('parking_vehicle_schema','two_plates_per_space_v1');data.append('parking_space_no',parking_space_no);if(plate_no)data.append('plate_no',plate_no);if(plate_no_2)data.append('plate_no_2',plate_no_2);if(parking_space_no_2)data.append('parking_space_no_2',parking_space_no_2);if(plate_no_3)data.append('plate_no_3',plate_no_3);if(plate_no_4)data.append('plate_no_4',plate_no_4);}
      if(residentType==='租户'){
        data.append('workplace',workplace);
        if(leaseContractFile)data.append('lease_contract',leaseContractFile);
        if(leaseContractFile&&leaseStartDate)data.append('lease_start_date',leaseStartDate);
        if(leaseContractFile&&leaseEndDate)data.append('lease_end_date',leaseEndDate);
      }
      await API.post('/users/register',data,{headers:{'Content-Type':'multipart/form-data'}});setSuccess(true);
    }catch(e){setError(e.response?.data?.message||'注册失败');}finally{setLoading(false);}
  };

  if(success)return <div style={styles.container}><div style={styles.card}><div style={{fontSize:48}}>✅</div><h2 style={styles.title}>申请已提交</h2><p style={styles.subtitle}>物业审核通过后即可登录使用，请等待物业审核。</p><button style={styles.btn} onClick={()=>navigate('/login')}>返回登录</button></div></div>;
  return <div style={styles.container}><div style={styles.card}>
    <FaceCamera
      open={cameraOpen}
      onClose={()=>setCameraOpen(false)}
      onCapture={(file,url)=>{
        setFaceFile(file);
        setFacePreview(url);
        setCameraOpen(false);
      }}
    />
    <div style={styles.logoText}>☁️</div><h2 style={styles.title}>业主/租户注册</h2><p style={styles.subtitle}>先选择物业已经建立的房屋</p>
    <div style={styles.label}>注册身份（每套房各限2个账号）</div><div style={styles.radioGroup}>{['业主','租户'].map(type=><button key={type} type="button" style={{...styles.radioBtn,...(residentType===type?styles.radioBtnActive:{})}} onClick={()=>{setResidentType(type);resetParking()}}>{type}</button>)}</div>
    <div style={styles.label}>选择楼幢</div><div style={styles.radioGroup}>{buildings.map(item=><button key={item} type="button" style={{...styles.radioBtn,...(building===item?styles.radioBtnActive:{})}} onClick={()=>{setBuilding(item);resetBelow('building')}}>{item}</button>)}</div>
    {!!building&&<><div style={styles.label}>选择单元</div><div style={styles.radioGroup}>{units.map(item=><button key={item} type="button" style={{...styles.radioBtn,...(unit===item?styles.radioBtnActive:{})}} onClick={()=>{setUnit(item);resetBelow('unit')}}>{item}</button>)}</div></>}
    {!!unit&&<><div style={styles.label}>选择楼层</div><select style={styles.select} value={floor} onChange={e=>{setFloor(e.target.value);setPropertyId('');resetParking()}}><option value="">请选择楼层</option>{floors.map(item=><option key={item} value={item}>{item}层</option>)}</select></>}
    {!!floor&&<><div style={styles.label}>选择房号</div><div style={styles.roomGrid}>{rooms.map(property=>{const used=residentType==='业主'?Number(property.owner_accounts):Number(property.tenant_accounts);return <button key={property.id} type="button" disabled={used>=2} style={{...styles.roomBtn,...(String(propertyId)===String(property.id)?styles.radioBtnActive:{}),...(used>=2?styles.disabled:{})}} onClick={()=>{setPropertyId(String(property.id));resetParking()}}><b>{property._floor}{property._room}室</b><small>{property.owner_name_masked}</small><small>{residentType} {used}/2</small></button>;})}</div></>}
    {!!selected&&<div style={styles.selected}>已选择：<b>{selected.room_no}</b><span>{residentType}账号 {slotCount}/2</span></div>}
    <input ref={nameRef} style={styles.input} placeholder="本人真实姓名"/>

    <div style={styles.label}>本人手机号码（登录账号）</div>
    <div style={styles.smsRow}>
      <input
        ref={phoneRef}
        style={{...styles.input,marginBottom:0}}
        placeholder="请输入本人11位手机号码"
        type="tel"
        inputMode="numeric"
        maxLength={11}
        disabled={smsVerified}
        onChange={resetSmsVerification}
      />
      <button
        type="button"
        style={styles.smsBtn}
        disabled={smsBusy||smsVerified||smsCooldown>0}
        onClick={sendSms}
      >
        {smsVerified?'✓ 已验证':smsBusy?'处理中...':smsCooldown>0?`${smsCooldown}秒`:'获取验证码'}
      </button>
    </div>

    <div style={styles.label}>短信验证码</div>
    <div style={styles.smsRow}>
      <input
        style={{...styles.input,marginBottom:0}}
        value={smsCode}
        disabled={smsVerified}
        inputMode="numeric"
        maxLength={6}
        placeholder="请输入6位验证码"
        onChange={e=>setSmsCode(e.target.value.replace(/\D/g,'').slice(0,6))}
      />
      <button
        type="button"
        style={styles.smsBtn}
        disabled={smsBusy||smsVerified||smsCode.length!==6}
        onClick={verifySms}
      >
        {smsVerified?'✓ 已验证':'验证'}
      </button>
    </div>

    {smsVerified&&<div style={styles.smsOk}>✓ 手机号码已验证，登录账号即为该手机号</div>}
    {smsInfo&&!smsVerified&&<div style={styles.smsInfo}>{smsInfo}</div>}
    <div style={styles.tip}>业主和租户均须验证本人手机号；审核通过后直接使用该手机号登录。</div>
    {residentType==='业主'&&<div style={styles.parkingBox}>
      <div style={styles.label}>车位1</div>
      <select style={styles.select} value={parking1} onChange={e=>{const v=e.target.value;setParking1(v);if(v==='无'){setPlate1('');setPlate2('');setParking2('');setPlate3('');setPlate4('');setShowParking2(false);}}}><option value="">请选择车位号</option><option value="无">无</option>{Array.from({length:660},(_,i)=>String(i+1).padStart(3,'0')).map(no=><option key={no} value={no}>{no}</option>)}</select>
      <div style={styles.label}>车牌1</div><input style={styles.input} disabled={!parking1||parking1==='无'} value={plate1} onChange={e=>setPlate1(e.target.value.toUpperCase())} placeholder="车牌1（可选，如浙C12345）"/>
      <div style={styles.label}>车牌2</div><input style={styles.input} disabled={!parking1||parking1==='无'} value={plate2} onChange={e=>setPlate2(e.target.value.toUpperCase())} placeholder="车牌2（可选）"/>
      {!showParking2&&parking1&&parking1!=='无'&&<button type="button" style={styles.addParking} onClick={()=>setShowParking2(true)}>＋ 添加车位2</button>}
      {showParking2&&<div style={styles.secondParking}>
        <div style={styles.secondHead}><b>第二个车位</b><button type="button" style={styles.removeParking} onClick={()=>{setParking2('');setPlate3('');setPlate4('');setShowParking2(false)}}>移除车位2</button></div>
        <div style={styles.label}>车位2</div><select style={styles.select} value={parking2} onChange={e=>setParking2(e.target.value)}><option value="">请选择第二个车位</option>{Array.from({length:660},(_,i)=>String(i+1).padStart(3,'0')).map(no=><option key={no} value={no}>{no}</option>)}</select>
        <div style={styles.label}>车牌3</div><input style={styles.input} disabled={!parking2} value={plate3} onChange={e=>setPlate3(e.target.value.toUpperCase())} placeholder="车牌3（可选）"/>
        <div style={styles.label}>车牌4</div><input style={styles.input} disabled={!parking2} value={plate4} onChange={e=>setPlate4(e.target.value.toUpperCase())} placeholder="车牌4（可选）"/>
      </div>}
      <div style={styles.tip}>每个车位最多登记2个车牌；最多登记2个车位、4个车牌。审核通过后车位进入物业费主档，车牌进入房屋车辆档案。</div>
    </div>}<input ref={idCardNoRef} style={styles.input} placeholder="身份证号码" maxLength={18} autoCapitalize="characters"/><div style={styles.tip}>请录入身份证号码以便物业核验。</div>
    {residentType==='租户'&&<div style={styles.tenantBox}><div style={styles.tenantTitle}>📋 租户资料</div><div style={{...styles.tip,margin:'0 0 8px'}}>租户需填写工作单位/工作地点。</div><input ref={workplaceRef} style={styles.input} placeholder="工作单位/工作地点（必填）"/></div>}

    {residentType==='租户'&&<>
      <div style={styles.label}>本人身份证照片（租户必传）</div>
      <label style={styles.photoArea}>
        {idCardPreview?<img src={idCardPreview} style={styles.previewImg} alt="身份证"/>:<span>📷 点击拍摄本人身份证</span>}
        <input
          type="file"
          accept="image/*"
          
          style={{display:'none'}}
          onChange={e=>chooseFile(e,setIdCardFile,setIdCardPreview)}
        />
      </label>
      <div style={styles.tip}>租户用于物业实名审核，请拍摄本人身份证原件并确保姓名、证件号码清晰。</div>
    </>}
    
  {residentType==='租户'&&<>
    <div style={styles.label}>租赁合同（选传）</div>
    <label style={{...styles.photoArea,minHeight:120,flexDirection:'column',gap:10}}>
      {leaseContractPreview
        ? <img src={leaseContractPreview} alt="租赁合同"
            style={{maxWidth:'100%',maxHeight:280,objectFit:'contain'}}/>
        : <span>📷 点击拍摄租赁合同</span>}
      <span>{leaseContractName?'点击重新拍摄或替换照片':'请拍清房号、租期和双方签字'}</span>
      <input type="file" accept="image/*" 
        style={{display:'none'}} onChange={e=>{
          const file=e.target.files&&e.target.files[0];
          e.target.value='';
          if(!file)return;
          if(!file.type.startsWith('image/')){
            setError('请选择合同照片');
            return;
          }
          if(file.size>10*1024*1024){
            setError('合同照片不能超过10MB，请缩小后上传');
            return;
          }
          setLeaseContractFile(file);
          setLeaseContractName(file.name);
          setError('');
        }}/>
    </label>
    {leaseContractName&&<div style={{...styles.tip,marginTop:8,wordBreak:'break-all'}}>
      已选择：{leaseContractName}
    </div>}
    <div style={{...styles.tip,marginTop:8}}>
      未上传合同或未填写合同到期日期：审核通过后临时通行1个月。有合同且填写到期日期：按合同到期日授权。当前支持一张照片，可点击重拍。
    </div>
    <div style={styles.label}>租赁开始日期（选填）</div>
    <input type="date" style={styles.input}
      value={leaseStartDate}
      onChange={e=>setLeaseStartDate(e.target.value)}/>
    <div style={styles.label}>租赁到期日期（选填）</div>
    <input type="date" style={styles.input}
      value={leaseEndDate} min={leaseStartDate||undefined}
      onChange={e=>setLeaseEndDate(e.target.value)}/>
  </>}
  <div style={styles.label}>
      本人正脸照（审核通过后自动同步门禁）
    </div>

      <div onClick={()=>setCameraOpen(true)} style={{
      ...styles.photoArea,
      minHeight:320,
      padding:16,
      border:'2px dashed #7aa9d8',
      background:'#f7fbff',
      flexDirection:'column',
      gap:12
    }}>

      {facePreview?
        <img
          src={facePreview}
          alt="人脸"
          style={{
            ...styles.previewImg,
            width:'100%',
            maxHeight:320,
            objectFit:'contain'
          }}
        />
      :
        <div style={{width:'100%',textAlign:'center'}}>
          <img
            src="/images/face-capture-guide.png"
            alt="人脸拍摄示例"
            style={{
              display:'block',
              width:'100%',
              borderRadius:14
            }}
          />
        </div>
      }
      </div>

    <div style={styles.tip}>
      拍摄要求：只拍头肩正脸，脸部占画面40%～60%；
      不要戴口罩、墨镜、帽子；不要逆光，五官必须清晰。
    </div>

    <div style={{margin:'10px 0 14px'}}>
      <img
        src="/images/face-photo-examples.png"
        alt="人脸拍摄正确与错误示例"
        style={{
          display:'block',
          width:'100%',
          borderRadius:12
        }}
      />
    </div>
    <div style={{...styles.tip,background:'#f0f7ff',padding:10,borderRadius:8,marginBottom:10}}>登录账号：使用上方已验证的本人手机号码，无需另外设置账号。</div><input ref={passwordRef} style={styles.input} placeholder="设置密码（至少6位）" type="password"/><input ref={password2Ref} style={styles.input} placeholder="确认密码" type="password"/>
    {error&&<p style={styles.error}>{error}</p>}<button style={{...styles.btn,opacity:loading?.7:1}} onClick={handleSubmit} disabled={loading}>{loading?'提交中...':'提交注册申请'}</button><p style={styles.footer}>已有账号？ <Link to="/login" style={styles.link}>直接登录</Link></p>
  </div></div>;
}

const styles={container:{minHeight:'100vh',background:'linear-gradient(135deg,#1a4a8a,#2d7dd2)',display:'flex',alignItems:'center',justifyContent:'center',padding:20},card:{background:'#fff',borderRadius:16,padding:'28px 22px',width:'100%',maxWidth:430,boxShadow:'0 8px 32px rgba(0,0,0,.15)',textAlign:'center'},logoText:{fontSize:38},title:{margin:'0 0 4px',fontSize:22,color:'#1a4a8a'},subtitle:{margin:'0 0 18px',color:'#888',fontSize:13},label:{textAlign:'left',fontSize:13,color:'#555',fontWeight:700,margin:'10px 0 6px'},input:{display:'block',width:'100%',padding:'12px 14px',marginBottom:10,border:'1.5px solid #e0e0e0',borderRadius:8,fontSize:15,boxSizing:'border-box'},select:{display:'block',width:'100%',padding:'12px 14px',marginBottom:10,border:'1.5px solid #e0e0e0',borderRadius:8,fontSize:15,background:'#fff'},radioGroup:{display:'flex',flexWrap:'wrap',gap:7,marginBottom:8},radioBtn:{padding:'8px 14px',border:'1.5px solid #e0e0e0',borderRadius:18,background:'#fff',fontSize:13,color:'#333'},radioBtnActive:{background:'#1a4a8a',color:'#fff',borderColor:'#1a4a8a'},roomGrid:{display:'grid',gridTemplateColumns:'repeat(2,minmax(0,1fr))',gap:8},roomBtn:{display:'grid',gap:3,padding:10,border:'1.5px solid #d7dfea',borderRadius:10,background:'#fff',color:'#333'},disabled:{opacity:.45},selected:{display:'flex',justifyContent:'space-between',gap:8,background:'#eaf3ff',color:'#174f87',padding:10,borderRadius:8,margin:'10px 0',fontSize:13},tip:{fontSize:12,color:'#777',textAlign:'left',margin:'-4px 0 10px'},tenantBox:{background:'#fff7e6',border:'1px solid #ffd591',borderRadius:10,padding:12,margin:'10px 0',textAlign:'left'},tenantTitle:{fontWeight:700,color:'#d46b08',fontSize:13},photoArea:{display:'flex',alignItems:'center',justifyContent:'center',border:'1.5px dashed #ccc',borderRadius:8,padding:10,minHeight:70,background:'#fafafa',fontSize:13,color:'#888'},previewImg:{maxWidth:'100%',maxHeight:130,borderRadius:6},parkingBox:{background:'#f0f7ff',border:'1px solid #d0e8ff',borderRadius:10,padding:12,margin:'10px 0',textAlign:'left'},addParking:{width:'100%',border:'1.5px dashed #2d7dd2',background:'#fff',color:'#1a5da8',borderRadius:8,padding:'11px 12px',fontSize:14,fontWeight:700,margin:'2px 0 10px'},secondParking:{marginTop:8,paddingTop:10,borderTop:'1px solid #d0e8ff'},secondHead:{display:'flex',alignItems:'center',justifyContent:'space-between',gap:8,color:'#174f87',fontSize:13},removeParking:{border:0,background:'#fff1f0',color:'#cf1322',borderRadius:8,padding:'6px 9px',fontSize:12},smsRow:{display:'grid',gridTemplateColumns:'minmax(0,1fr) 108px',gap:8,marginBottom:10},
smsBtn:{border:0,borderRadius:8,background:'#1a5da8',color:'#fff',fontWeight:700,fontSize:13,padding:'0 10px',minHeight:44},
smsOk:{background:'#f0fff4',border:'1px solid #b7eb8f',color:'#237804',padding:'9px 10px',borderRadius:8,fontSize:13,textAlign:'left',marginBottom:10},
smsInfo:{background:'#fffbe6',border:'1px solid #ffe58f',color:'#ad6800',padding:'9px 10px',borderRadius:8,fontSize:13,textAlign:'left',marginBottom:10},
btn:{width:'100%',padding:14,background:'linear-gradient(90deg,#1a4a8a,#2d7dd2)',color:'#fff',border:0,borderRadius:8,fontSize:16,fontWeight:700},error:{color:'#ff4d4f',fontSize:13,textAlign:'left'},footer:{marginTop:15,fontSize:13,color:'#888'},link:{color:'#1a4a8a',fontWeight:700,textDecoration:'none'}};
